import NewsletterForm from '@/components/base/NewsletterForm';

const Subscribe = () => (
  <section id="subscribe" className="mx-auto max-w-content scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
    <div className="relative overflow-hidden rounded-lg border border-primary-200 bg-primary-50 p-6 md:p-10">
      <div
        className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-accent-200/50"
        aria-hidden="true"
      ></div>
      <div className="relative grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.1fr] lg:items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
            <i className="ri-mail-send-line text-sm"></i>
            每周一封，不打扰
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
            订阅爆料周报
            <span className="mt-2 block text-base font-normal text-foreground-600 md:text-lg">
              第一时间收到独家一手私料
            </span>
          </h2>
          <ul className="mt-5 space-y-2.5 text-sm text-foreground-700">
            <li className="flex items-center gap-2">
              <i className="ri-check-line text-base text-accent-600"></i>
              当周最值得看的 3 条爆料
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-check-line text-base text-accent-600"></i>
              1 个幕后行业的深度观察
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-check-line text-base text-accent-600"></i>
              随时可退订，邮箱不用于其他用途
            </li>
          </ul>
        </div>
        <div className="rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-6">
          <NewsletterForm />
        </div>
      </div>
    </div>
  </section>
);

export default Subscribe;